import { ShaderStore } from "@babylonjs/core/Engines/shaderStore";
const Name = "textureAlphaCheckerPixelShader";
const Shader = /* wgsl */ "\nvar textureSamplerSampler: sampler;var textureSampler: texture_2d<f32>;varying vUv: vec2f;@fragment\nfn main(input: FragmentInputs)->FragmentOutputs {fragmentOutputs.color=vec4f(\nvec3f(1.0)-vec3f(textureSample(textureSampler,textureSamplerSampler,fragmentInputs.vUv).a),\n1.0\n);}\n";
// Sideeffect
ShaderStore.ShadersStoreWGSL[Name] = Shader;
/** @internal */
export const TextureAlphaCheckerPixelShader = { name: Name, shader: Shader };
